import styled from 'styled-components';

export const StyledImageBanner = styled.div`
  img {
    border-radius: 1rem;
    cursor: pointer;
    width: 100%;
  }
`;
